/*
 * File: d:\projects\AutoFiFront\src\Content\Header\Header.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday January 13th 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Monday, 6th November 2023 11:02:59
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { useEffect, useState } from "react";
import translator from "MultiLanguage/TranslationWrapper";
import styles from "Content/Header/Header.module.css";
import NavLinkStyled from "Theme/Component/NavLinkStyled";
import { NavLink, useNavigate } from "react-router-dom";
import Burger from "Theme/Component/Burger";
import PhoneMenu from "Theme/Component/PhoneMenu";
import HeaderCart from "Content/HeaderCart/HeaderCart";
import 'Content/Header/Header.css';
import CookiePathResolver from "Config/Cookies/CookiePathResolver";
import Cookie from "Cookies/CookieWrapper";
import Logo2 from "Content/SVG/Logo/Logo2";
import RouterPathResolver from "Config/Router/RouterPathResolver";

const HeaderList = [
    {name: "home", path: RouterPathResolver.pathEntryPoint.path},
    {name: "carList", path:RouterPathResolver.routeCars.path},
    {name: "recovery", path:RouterPathResolver.routeBuyback.path},
    // {name: "financement", path:RouterPathResolver.routeFinance.path},
    // {name: "about", path:RouterPathResolver.routeAbout.path},
];

type HeaderPropsType = {
    themeColor: string,
    changeThemeColor: React.Dispatch<React.SetStateAction<string>>
};

type NavlinkStyleActiveType = {
    isActive: boolean,
    isPending: boolean
};

function Header(props: HeaderPropsType){
    const [toggleClass, settoggleClass] = useState(false);
    const carsInCart = Cookie.getCookie(CookiePathResolver.CAR.FAVORITE);
    const navigate = useNavigate();

    const toggle: any = () => {
        settoggleClass(!toggleClass);
    };
    useEffect(()=>{
        if(toggleClass)
            settoggleClass(!toggleClass);
    },[navigate]);

    const resetThemeColor: any = () =>{
        return props.changeThemeColor("");
    };
    const logoColor = props.themeColor== "CITYCAR" ? "var(--root-colors-second)" : props.themeColor == "SUV" ? "var(--root-colors-third)" : props.themeColor == "UTILITY" ? "var(--root-colors-fourth)" : props.themeColor == "SEDAN" ? "var(--root-colors-fifth)" : props.themeColor == "BREAK" ? "var(--root-colors-sixth)" : "var(--root-colors-first)";

    const activeStyle = {
        color:logoColor,
    };
    return (
        <React.Fragment>
            <header>
                <div className={`${styles.header}`}>
                    <NavLink className={`${styles.linkLogoHome}`} aria-label="Home Link" to={RouterPathResolver.pathEntryPoint.path}>
                        <Logo2 width="15rem" fill={logoColor} fill2={"var(--theme-bg-color)"} stroke={logoColor} strokeWidth={"10px"}/>
                    </NavLink>
                    <div className={`${styles.header_ul_wrapper}`}>
                        <ul className={`${styles.header_ul}`}>
                            {
                                HeaderList.map((item)=> {return <li key={item.name}>
                                    <NavLinkStyled onClick={resetThemeColor} bgColor={props.themeColor} style={(activeParam: NavlinkStyleActiveType) => ( activeParam.isActive ? activeStyle : {} )}
                                        to={item.path}>
                                        {translator.decode(`navbar.${item.name}`)}
                                    </NavLinkStyled>
                                </li>})
                            }
                        </ul>
                    </div>
                    <div className={`${styles.iconsHeader}`}>
                        <HeaderCart ids={carsInCart} themeColor={props.themeColor}/>
                        <div onClick={toggle} id={`${styles.menuBar}`} className={`${toggleClass ? styles.change : "" }`}>
                            <Burger id={`${styles.bar1}`} bgColor={props.themeColor} className={`${styles.bar}`} ></Burger>
                            <Burger id={`${styles.bar2}`} bgColor={props.themeColor} className={`${styles.bar}`} ></Burger>
                            <Burger id={`${styles.bar3}`} bgColor={props.themeColor} className={`${styles.bar}`} ></Burger>
                        </div>
                    </div>
                </div>
                <div className={`${toggleClass ? styles.hidden: styles.hiddenBis}`}>
                    <div className={`${toggleClass ? styles.navPhoneRight : styles.displayNone}`}>
                        <div className={`${styles.nav}`}>
                            <ul className={`${styles.header_ul_phone}`}>
                                {
                                    HeaderList.map((item)=> {return <li key={item.name}>
                                        <NavLink onClick={()=>{resetThemeColor(); toggle()}} className={`${styles.liPhone}`} to={item.path}>
                                            {translator.decode(`navbar.${item.name}`)}
                                        </NavLink>
                                    </li>})
                                }
                            </ul>
                        </div>
                        <div className={`${styles.menuPhonePop}`}>
                            <PhoneMenu bgColor={props.themeColor}></PhoneMenu>
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    )
}

export default Header;
